/* ─────────────────────────────────────────────
   Stolen Bell — Header JS
   Mega-menu, sticky scroll, keyboard nav
   ───────────────────────────────────────────── */

(function () {
  'use strict';

  const header    = document.getElementById('site-header');
  const items     = document.querySelectorAll('.sb-mega-nav__item');
  const isOverlay = header && header.dataset.overlay === 'true';

  if (header) {
    const setHeight = () => {
      document.documentElement.style.setProperty(
        '--header-height', header.offsetHeight + 'px'
      );
    };
    setHeight();
    window.addEventListener('resize', setHeight, { passive: true });
    window.addEventListener('load', setHeight, { passive: true });

    /* Overlay pages start with a transparent header floating over the
       hero. Once the user scrolls past a small threshold we add
       .is-sticky to swap in the opaque white treatment. Position is
       handled by CSS sticky on every template, so no body padding or
       fixed-positioning juggling needed. */
    if (isOverlay) {
      window.addEventListener('scroll', () => {
        const y = window.scrollY;
        if (y > header.offsetHeight && !header.classList.contains('is-sticky')) {
          header.classList.add('is-sticky');
        } else if (y <= 10 && header.classList.contains('is-sticky')) {
          header.classList.remove('is-sticky');
        }
      }, { passive: true });
    }
  }

  /* ── Mega-menu helpers ── */
  function openItem(item) {
    const trigger = item.querySelector('.sb-mega-nav__trigger');
    const panel   = item.querySelector('.sb-mega-panel');
    if (!trigger || !panel) return;

    items.forEach(other => { if (other !== item) closeItem(other); });

    item.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    panel.setAttribute('aria-hidden', 'false');

  }

  function closeItem(item) {
    const trigger = item.querySelector('.sb-mega-nav__trigger');
    const panel   = item.querySelector('.sb-mega-panel');
    if (!trigger || !panel) return;

    item.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    panel.setAttribute('aria-hidden', 'true');
  }

  function closeAll() {
    items.forEach(closeItem);
  }

  /* ── Click triggers ── */
  items.forEach(item => {
    const trigger = item.querySelector('.sb-mega-nav__trigger');
    if (!trigger) return;

    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      item.classList.contains('is-open') ? closeAll() : openItem(item);
    });
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.sb-mega-nav__item') && !e.target.closest('.sb-mega-panel')) {
      closeAll();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeAll();
      const openTrigger = document.querySelector('.sb-mega-nav__trigger[aria-expanded="true"]');
      if (openTrigger) openTrigger.focus();
    }
  });

  document.addEventListener('focusin', (e) => {
    if (header && !header.contains(e.target)) closeAll();
  });

})();

/* ── Mobile overlay ── */
(function () {
  const navOverlayToggle = document.getElementById('nav-overlay-toggle');
  const navOverlayClose  = document.getElementById('nav-overlay-close');
  const navOverlayMenu   = document.getElementById('nav-overlay-menu');
  const navOverlayBox    = document.getElementById('nav-overlay-box');

  if (!navOverlayToggle) return;

  navOverlayToggle.addEventListener('click', () => {
    navOverlayToggle.setAttribute('aria-expanded', 'true');
    navOverlayMenu.setAttribute('aria-hidden', 'false');
  });

  navOverlayClose.addEventListener('click', () => {
    navOverlayToggle.setAttribute('aria-expanded', 'false');
    navOverlayMenu.setAttribute('aria-hidden', 'true');
  });

  window.addEventListener('click', (e) => {
    if (navOverlayMenu.getAttribute('aria-hidden') === 'false') {
      if (e.target.contains(navOverlayBox) && e.target !== navOverlayBox) {
        navOverlayToggle.setAttribute('aria-expanded', 'false');
        navOverlayMenu.setAttribute('aria-hidden', 'true');
      }
    }
  });
})();

/* ── Mobile mega-nav accordion ──
   Each top-level nav item in the mobile drawer toggles a panel that
   mirrors the desktop mega-panel's eyebrow + links + CTAs. Only one
   panel can be open at a time so the drawer stays compact. */
(function () {
  const triggers = document.querySelectorAll('.sb-mobile-nav__trigger');
  if (!triggers.length) return;

  function closePanel(trigger) {
    const panel = document.getElementById(trigger.getAttribute('aria-controls'));
    trigger.setAttribute('aria-expanded', 'false');
    if (panel) panel.setAttribute('aria-hidden', 'true');
  }

  triggers.forEach(trigger => {
    const panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!panel) return;

    trigger.addEventListener('click', () => {
      const wasOpen = trigger.getAttribute('aria-expanded') === 'true';
      triggers.forEach(closePanel);
      if (!wasOpen) {
        trigger.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-hidden', 'false');
      }
    });
  });
})();
